import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AssignmentService {
  private fileData = null;
  public fileModeSubject = new BehaviorSubject<any>(null);

  setFileData(data: any) {
    this.fileData = data;

    const localStorageData: string = this.fileData ? JSON.stringify(this.fileData) : 'null';

    localStorage.setItem('currentAssignmentFileData', localStorageData);
  }

  getFileData() {
    return this.fileData;
  }

  getFileData$() {
    return this.fileModeSubject.asObservable();
  }

  setFileDataOnReload() {
    let isAssignmentFileDataExist = null;
    try {
      const storedFileData = localStorage.getItem('currentAssignmentFileData');
      isAssignmentFileDataExist = storedFileData ? JSON.parse(storedFileData) : null;
    } catch (e) {
      /* Truncated or corrupted. This runs from the canvas dashboard constructor, outside the
         try/catch further down it, so throwing here stops the component being created at all and
         the file silently never opens. Drop the bad value and carry on without assignment data. */
      localStorage.removeItem('currentAssignmentFileData');
    }

    if (isAssignmentFileDataExist && !this.fileData) {
      this.fileData = isAssignmentFileDataExist;
    }
  }

  setUpdatedPermissionsAndStatus(permissions: any, status: string) {
    const fileData: any = this.fileData;
    const updatedFileData = {
      ...fileData,
      assignmentPermissions: permissions,
      assignmentStatus: status,
    };

    this.fileData = updatedFileData;
    this.setFileData(this.fileData);
  }

  clearAssignmentFileData() {
    this.fileData = null;
    this.fileModeSubject.next(false);
    localStorage.removeItem('currentAssignmentFileData');
  }
}
